import { useEffect } from "react";
import { useFreeShippingPopup } from "../../dev/useFreeShippingPopup";

const FreeShippingPopup = () => {
  const { showPopup } = useFreeShippingPopup();

  useEffect(() => {
    const fetchPopup = async () => {
      await showPopup(21);
    };

    fetchPopup();
  }, []);

  return null;
};

export default FreeShippingPopup;
